import { render, staticRenderFns } from "./VolunteerCard.vue?vue&type=template&id=6d2adf42&scoped=true"
import script from "./VolunteerCard.vue?vue&type=script&lang=js"
export * from "./VolunteerCard.vue?vue&type=script&lang=js"
import style0 from "./VolunteerCard.vue?vue&type=style&index=0&id=6d2adf42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2adf42",
  null
  
)

export default component.exports